/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');
var moment = require('moment');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllComplianceRegistrationLookups = require('../services/GetAllComplianceRegistrationLookups');
var SecExtCompRegNewView = require('../views/SecExtCompRegNewView');
var SecExtCompRegCutoffView = require('../views/SecExtCompRegCutoffView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetAllComplianceRegistrationLookups())
    .done(function(complianceLookups) {
      NavUtils.navigate('#ext/sec/compreg/new');
      var currentYYYYMMDD = moment().format('YYYYMMDD');
      if (
        complianceLookups.registrationStartDate <= currentYYYYMMDD &&
        currentYYYYMMDD <= complianceLookups.registrationEndDate
      ) {
        Scaffold.content.show(
          new SecExtCompRegNewView({
            model: new Backbone.Model({
              professionalTypes: complianceLookups.professionalTypes,
              registrationFee: complianceLookups.registrationFee
            })
          })
        );
      } else {
        Scaffold.content.show(new SecExtCompRegCutoffView({}));
      }
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
